// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'react-datepicker';


class AddCompetitionExpense extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      status_types: [],
      expense_types: [],
      buddy_search_list:[],
      purposes:[],
      expense_details: {
        competition_id:props.match.params.id,
        purpose: 1,
        item: '',
        quantity:0,
        size:'',
        amount:0,
        bill:'',
        status:1,
        paid_by:'',
        paid_on_date:moment(),
        expense_type:10,
        mobile_no:'',
      },
      data_uploaded: false,
      data_error: false,
      addExpenseView:false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFilebill = this.handleFilebill.bind(this);
    this.getCompetitionExpenseInputs = this.getCompetitionExpenseInputs.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.getSearchList = this.getSearchList.bind(this);
    this.setSearch = this.setSearch.bind(this);
  }

  componentDidMount() {
    this.getCompetitionExpenseInputs();
    console.log(this.state);
  }
  getCompetitionExpenseInputs() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_competition_expense/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState({status_types: data.status_types,expense_types: data.expense_types,purposes:data.purposes});
        })
       .catch(error => error);
  }

  getSearchList() {
        const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'search': this.state.expense_details.mobile_no
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({buddy_search_list: data.results, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }

  setSearch(name, buddy_id, mobile_no){
        var new_selected_one =  Object.assign({}, this.state.expense_details);
        new_selected_one['paid_by'] = buddy_id
        new_selected_one['paid_by_name'] = name
        this.setState({expense_details: new_selected_one, search: false});
    }

  postaddExpense(data, props) {
    console.log(data);
    if(data.purpose == '' || data.item == '' || (data.status == 1 && data.paid_by == '') ){
      alert('Please provide necessary data')
    }
    else{
    const url = `${getLocationOrigin()}/tournament/add_competition_expense/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    for(var name in data) {
      formData.append(name, data[name]);
    }
    options['method'] = 'post';
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) =>{                      // first then()
          alert(response.message);
          this.props.history.goBack();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
    }
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.expense_details);
    new_selected_one[name] = event.target.value
    this.setState({expense_details: new_selected_one});
  }
  handleDateChange(date){
    var new_selected_one =  Object.assign({}, this.state.expense_details);
    new_selected_one['paid_on_date'] = date
    this.setState({expense_details: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postaddExpense(this.state.expense_details, this.props);
    console.log('post');
    console.log(this.state);
  }
  toAddExpense(){
    this.props.history.goBack();
  }

  handleFilebill(selectorFiles: FileList){
    var new_selected_one =  Object.assign({}, this.state.expense_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['bill'] = selectorFiles[0]
    this.setState({expense_details: new_selected_one});
  }

  render() {
    console.log(this.state)
    return(
      <div className="col-md-12 " style={styles.container}>
        
        
        <div className="col-md-8 table_container1">
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add Competition Expense</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Purpose 
              </div>
              <div className="col-md-6 input-group">
                <select name="purpose" className="col-md-6" style={styles.item_body} value={this.state.value}
                      onChange={this.handleChange}>
                      {
                        this.state.purposes.map((x, index) => (
                        <option key={x[0]} value={x[0]}>{x[1]}</option>
                        ))
                      }
                    </select>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Item 
              </div>
              <div className="col-md-6 input-group">
                <input type="text" style={styles.input} name="item" className="required"
                  value={this.state.value} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Quantity 
              </div>
              <div className="col-md-6 input-group">
                <input type="number" style={styles.input} name="quantity" className="required"
                  value={this.state.value} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Size
              </div>
              <div className="col-md-6 input-group">
                <input type="text" style={styles.input} name="size" className="required"
                  value={this.state.value} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Amount 
              </div>
              <div className="col-md-6 input-group">
                <input type="number" style={styles.input} name="amount" className="required"
                  value={this.state.value} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Type
              </div>
              <div className="col-md-6 input-group">
                <select name="type" className="col-md-6" style={styles.item_body} value={this.state.value}
                      onChange={this.handleChange}>
                      {
                        this.state.expense_types.map((x, index) => (
                        <option key={x[0]} value={x[0]}>{x[1]}</option>
                        ))
                      }
                    </select>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Status 
              </div>
              <div className="col-md-6 input-group">
                <select name="status" className="col-md-6" style={styles.item_body} value={this.state.value}
                      onChange={this.handleChange}>
                      {
                        this.state.status_types.map((x, index) => (
                        <option key={x[0]} value={x[0]}>{x[1]}</option>
                        ))
                      }
                    </select>
              </div>
            </div>
            {this.state.expense_details.status == 1 &&
              <div>
            {this.state.expense_details.paid_by != '' &&
            <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                    Paid By 
                </div>
                <div  className="col-md-5">
                {this.state.expense_details.paid_by_name}
                  </div>
            </div>
            }
            <div style={styles.items} className="col-md-12" >
                        <div style={styles.item_header} className="col-md-6">
                            Search payer
                        </div>
                        <div className="col-md-6 input-group" style={{display:'flex',flexDirection:'row'}}>
                                <input type="text" name="mobile_no" className="col-md-8" 
                                placeholder="Paid By .." value={this.state.mobile_no} onChange={(e) =>{this.handleChange(e)}}/>
                                <div className="col-md-1">
                                <span className="input-group-btn">
                                <button className="btn btn-default glyphicon glyphicon-search"
                                type="button" onClick={this.getSearchList}></button>
                                </span>
                                </div>
                         </div>
                    </div>
                        {this.state.search?
                            <div className="col-md-12 btn-group">
                                {this.state.buddy_search_list.length?this.state.buddy_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                            style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                            :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                            <div className="alert alert-danger">Search customer not found</div>
                            <div>
                            <RaisedButton
                            onClick={this.handleOpen}
                            label="Add"
                            style={{float:'right'}}
                            secondary={true}
                            />
                            <Dialog
                            actions={actions}
                            modal={false}
                            open={this.state.dialog_open_cust}
                            onRequestClose={this.handleClose}
                            >
                            <div>
                                <div style={styles.main_header} className="col-md-12">
                                <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                                </div>
                                <div style={styles.items} className="col-md-12">
                                <div style={styles.item_header} className="col-md-6">
                                    Name
                                </div>
                                <input type="text" style={styles.input} name="cust_name" className="required"
                                    value={this.state.value} onChange={this.handleChange}/>
                                </div>

                                <div style={styles.items} className="col-md-12">
                                <div style={styles.item_header} className="col-md-6">
                                    Mobile No
                                </div>
                                <input type="number" style={styles.input} name="cust_mobile_no" className="required"
                                    value={this.state.mobile_no} onChange={this.handleChange}/>
                                </div>
                            </div>
                            </Dialog>
                        </div>
                        </div>
                    }</div>:''}
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Paid on Date 
              </div>
              <div className="col-md-6 input-group">
                <DatePicker name="paid_on_date"  selected={this.state.expense_details.paid_on_date} onChange={this.handleDateChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Upload Bill
              </div>
              <div className="col-md-6 input-group">
                  <input type="file" style={styles.input} name="bill" onChange={ (e) => this.handleFilebill(e.target.files) }/>
              </div>
            </div>
            </div>
          }
            
            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Submit" />
              <input className="button1" type="button" value="Cancel" style={{backgroundColor:'red',color:'#ffffff',marginLeft:'20px'}} onClick={() => {this.toAddExpense()}} />
            </div>
          </form>
        </div>
        
      </div>
    );
  }
}

export default AddCompetitionExpense;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addCompetitionExpense/index.js